/**
 * Hooks index file for PropertyComments
 * Exports all custom hooks following SOLID principles
 */

export { useCommentData } from "./useCommentData";
export { useCommentActions } from "./useCommentActions";

export type { UseCommentDataProps } from "./useCommentData";
export type { UseCommentActionsProps } from "./useCommentActions";
